import React from 'react';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Button,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Badge
} from 'reactstrap';
import CheckBox from '../../../componentes/checkbox/checkbox.component';
import './inconformidade.style.css';
import * as acessos from '../../../acessos.const.util';
import uniqBy from 'lodash/uniqBy';
import ReactToPrint from 'react-to-print';
import TermoConsolidadoTemplate from './modelos/termo.consolidado.template';
import TermoIndividualTemplate from './modelos/termo.individual.template';
import { acessoPermitido } from '../../../acessos.seguranca';
import SelectComponent from '@componentes/select/select.component';
import IntlMessage from '../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

export const InconformidadePage = props => {
  const intl = useIntl();

  function translate(key) {
    return intl.formatMessage({ id: key });
  }
  return (
  <div className='nao-conformidade-container'>
    <Modal isOpen={props.openModalImprimirIndividual}>
      <ModalHeader toggle={props.toggleModalImprimirIndividual}>
        <IntlMessage id = "dashboards.examDetail.printIndividualTerm"/>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <FormGroup>
              <Label><IntlMessage id = "dashboards.examDetail.printer"/></Label>
              <SelectComponent
                options={props.impressoras}
                placeholder={translate("dashboards.examDetail.selectPrinter")}
                onChange={props.atualizarImpressora}
                value={props.impressora}
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={props.toggleModalImprimirIndividual}>
          <IntlMessage id = "dashboards.examDetails.cancel"/>
        </Button>
        <Button
          color='primary'
          onClick={props.imprimirTermoIndividual}
          disabled={!props.impressora}
        >
          <IntlMessage id = "dashboards.taskControl.printOut"/>
        </Button>
      </ModalFooter>
    </Modal>

    <Modal isOpen={props.openModalImprmirConsolidado}>
      <ModalHeader toggle={props.toggleModalImprmirConsolidado}>
        <IntlMessage id = "dashboards.examDetail.printConsolidatedTerm"/>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <Label><IntlMessage id = "dashboards.examDetail.Unconformities"/></Label>
            <div>
              {uniqBy(props.historico, 'nConfId').map((el, key) => {
                if (!el.bloquearImprimir) {
                  return (
                    <CheckBox
                      key={key}
                      label={el.descricao}
                      onChange={() => props.selecaoItemCheckbox(el.nConfId)}
                      checked={props.itemCheckboxIsSelecionado(el.nConfId)}
                    />
                  );
                }
              })}
            </div>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={props.toggleModalImprmirConsolidado}>
              <IntlMessage id = "dashboards.examDetails.cancel"/>
        </Button>
        <ReactToPrint
          documentTitle={
            props.termoNConfConsolidado.dadosGeraisHospital.razaosoc
          }
          trigger={() => (
            <Button
              color='primary'
              disabled={props.itensCheckboxNConf.length === 0}
            >
               <IntlMessage id = "dashboards.taskControl.printOut"/>
            </Button>
          )}
          content={() => this.termoConsolidadoTemplateRef}
          onBeforeGetContent={props.imprimirTermoAnuencia}
          onAfterPrint={() => {
            props.loading(false);
            props.toggleModalImprmirConsolidado();
          }}
        />
      </ModalFooter>
    </Modal>

    <Modal size={'lg'} isOpen={props.openModal} toggle={props.toggleModal}>
      <ModalHeader toggle={props.toggleModal}>
        <IntlMessage id = "dashboards.examDetail.addNonconformity"/>
      </ModalHeader>
      <div className='nao-conformidade-modal'>
        <Row>
          <Col style={{ fontSize: '14px' }}>
            <FormGroup>
              <Label><IntlMessage id = "dashboards.examDetail.unconformities"/></Label>
              <SelectComponent
                options={props.naoconformidades}
                onChange={props.onChange}
                value={props.nConf}
                placeholder={translate("dashboards.examDetail.selectUnconformities")}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Input
                type='textarea'
                name='anotacoesNaoConformidade'
                value={props.observacao}
                onChange={props.modalOnChangeTexto}
                maxLength={250}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm='auto'>
            <FormGroup className='checkbox-adicionar'>
              <CheckBox
                label={<IntlMessage id = "dashboards.examDetail.displayNoncompliance"/>}
                onChange={props.exibirNaoConformidadeNoLaudoChangeValor}
                checked={props.exibirNaoConformidadeNoLaudo}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className='linha-btn-adicionar'>
          <Col>
            <Button
              color='primary'
              className='inconformidade-btn-adicionar'
              disabled={!props.nConf}
              onClick={props.adicionarNConfNaLista}
            >
              <IntlMessage id = "dashboards.examDetail.adding"/>
            </Button>
          </Col>
        </Row>
        {props.listaNConf.length > 0 && (
          <Row>
            <Col className='inconformidades-container'>
              {props.listaNConf.map((el, index) => (
                <Row key={index}>
                  <Col>
                    <Card>
                      <CardBody className='card-inconformidade'>
                        <CardTitle>
                          {el.label}
                          <Button
                            color='link'
                            onClick={props.removerItemListaNConf.bind(
                              this,
                              el.value
                            )}
                          >
                            <i className='fas fa-trash'></i>
                          </Button>
                        </CardTitle>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              ))}
            </Col>
          </Row>
        )}
      </div>
      <ModalFooter>
        <Button color='secondary' onClick={props.toggleModal}>
          <IntlMessage id = "dashboards.examDetails.cancel"/>
        </Button>
        <Button
          name='imprimir'
          color='primary'
          onClick={props.onClick}
          disabled={props.listaNConf.length === 0}
        >
          <IntlMessage id = "dashboards.examDetail.confirmPrintConsolidated"/>{' '}
          <i className='mv-basico-imprimir'></i>
        </Button>
        <Button
          color='primary'
          onClick={props.onClick}
          disabled={props.listaNConf.length === 0}
        >
          <IntlMessage id = "dashboards.examDetail.confirmClose"/>
        </Button>
      </ModalFooter>
    </Modal>
    {acessoPermitido(props.usuario, acessos.NaoConformidades) &&
      acessoPermitido(props.usuario, acessos.AdicionarNaoConformidade) && (
        <Row style={{ marginTop: '9px' }}>
          <Col sm='auto'>
            <FormGroup>
              <Button
                color='primary'
                className='btn-nconf'
                onClick={props.toggleModal}
              >
                <IntlMessage id = "dashboards.examDetail.adding"/>
              </Button>
            </FormGroup>
          </Col>
          {props.historico && props.historico.length > 0 && (
            <Col sm='auto' style={{ paddingLeft: 0 }}>
              <FormGroup>
                <Button
                  color='success'
                  className='btn-nconf'
                  onClick={props.toggleModalImprmirConsolidado}
                >
                  <IntlMessage id = "dashboards.examDetail.printConsolidatedTerm"/>
                </Button>
              </FormGroup>
            </Col>
          )}
        </Row>
      )}
    {props.historico && props.historico.length > 0 && (
      <div
        style={{
          height: `${props.altura - 88}px`,
          overflowY: 'scroll',
          overflowX: 'hidden'
        }}
      >
        {props.historico.map(item => {
          const resolucao =
            item.resolucao !== ''
              ? `(Resolvida em ${item.resolucao})`
              : '(Pendente)';
          return (
            <Row key={item.id}>
              <Col>
                <Card>
                  <CardBody className='card-inconformidade'>
                    <CardTitle>
                      {`${item.descricao} ${resolucao}  `}
                      {item.resolucao === '' && !item.bloquearImprimir && (
                        <ReactToPrint
                          trigger={() => (
                            <Badge color='success' pill>
                              <a className='mv-basico-imprimir'> </a>
                              <IntlMessage id = "dashboards.examDetail.printTerm"/>
                            </Badge>
                          )}
                          content={() => this.termoIndividualTemplateRef}
                          onBeforeGetContent={props.imprimirTermoIndividual.bind(
                            this,
                            item.id
                          )}
                          onAfterPrint={() => {
                            props.limparTermoNConfIndividual();
                            props.loading(false);
                          }}
                        />
                      )}
                    </CardTitle>
                    <CardText>
                      {`Incluida em ${item.inclusao} na etapa `}
                      <span>{item.etapa}</span>
                    </CardText>
                    {item.resolucao === '' && item.observacao && (
                      <div className='label_justificativa'>
                        <Label><IntlMessage id = "dashboards.disposalMaterials.modal.observation"/></Label>
                        {`  ${item.observacao}`}
                      </div>
                    )}
                    {item.resolucao !== '' && (
                      <div className='label_justificativa'>
                        <Label><IntlMessage id = "dashboards.examDetails.justification"/></Label>
                        {`  ${item.justificativa}`}
                      </div>
                    )}
                    <FormGroup check>
                      <Label check>
                        <Input
                          type='checkbox'
                          checked={item.exibidaNoTextoFinalLaudo}
                          disabled={
                            props.disableInclusaoNaoConformidade ||
                            item.bloquearImprimir ||
                            (!acessoPermitido(
                              props.usuario,
                              acessos.NaoConformidades
                            ) &&
                              !acessoPermitido(
                                props.usuario,
                                acessos.AdicionarNaoConformidade
                              ))
                          }
                          onChange={e =>
                            props.atualizarExibicaoNaoConformidadeNoTextoFinalLaudo(
                              item.id,
                              e.currentTarget.checked
                            )
                          }
                          readOnly={true}
                        />{' '}
                        <IntlMessage id = "dashboards.cytology.nonComplianceDisplayed"/>
                      </Label>
                    </FormGroup>
                    {item.resolucao === '' &&
                      acessoPermitido(
                        props.usuario,
                        acessos.NaoConformidades
                      ) &&
                      acessoPermitido(props.usuario, acessos.Resolver) && (
                        <div className='mt-2'>
                          <FormGroup className='mb-1'>
                            <Input
                              type='textarea'
                              name='text'
                              onChange={e => {
                                props.setJustificativa(e.target.value);
                              }}
                              required
                            />
                          </FormGroup>
                          <FormGroup className='mb-0'>
                            <Button
                              color='link'
                              onClick={() => {
                                props.resolverNaoConformidade(item.id);
                              }}
                              disabled={!props.existeJustificativa()}
                            >
                              <i className='mv-basico-confirmar'></i>
                              <IntlMessage id = "dashboards.cytology.solve"/>
                            </Button>
                          </FormGroup>
                        </div>
                      )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          );
        })}
      </div>
    )}
    <div style={{ display: 'none' }}>
      <TermoConsolidadoTemplate
        ref={el => (this.termoConsolidadoTemplateRef = el)}
        termoNConfConsolidado={props.termoNConfConsolidado}
      />
    </div>
    <div style={{ visibility: 'hidden', position: 'fixed' }}>
      <TermoIndividualTemplate
        ref={el => (this.termoIndividualTemplateRef = el)}
        termoNConfConsolidado={props.termoNConfConsolidado}
        onload={props.onload}
        altura={props.altura}
      />
    </div>
  </div>
);
}



// WEBPACK FOOTER //
// ./src/app/common/inconformidade/inconformidade.page.js